import React from 'react';
import clsx from 'clsx';
import { Modal } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classname from './SuccessAnimated.module.scss';
import './SuccessAnimated.scss';

const SuccesAnimated = (props) => {
    const { open, handleClose, children, type } = props;
    const succesIcon = (
        <div className={clsx(classname.modalIcon, classname.modalSuccess, classname.animate)}>
            <span className={clsx(classname.modalLine, classname.modalTip, classname.animateSuccessTip)} />
            <span className={clsx(classname.modalLine, classname.modalLong, classname.animateSuccessLong)} />
            <div className={clsx(classname.modalPlaceholder)} />
            <div className={clsx(classname.modalFix)} />
        </div>)
    const warningIcon = (
        <div className={clsx(classname.modalIcon, classname.modalWarning, classname.scaleWarning)}>
            <span className={clsx(classname.modalWarningBody, classname.pulseWarningIns)} />
            <span className={clsx(classname.modalWarningDot, classname.pulseWarningIns)} />
        </div>)
    const errorIcon = (
        <div className={clsx(classname.modalIcon, classname.modalError, classname.animate)}>
            <span className={classname.modalXmark}>
                <span className={clsx(classname.modalLine, classname.modalLeft, classname.animateXLeft)} />
                <span className={clsx(classname.modalLine, classname.modalRight, classname.animateXRight)} />
            </span>
            <div className={classname.modalPlaceholder} />
            <div className={classname.modalFix} />
        </div>)
    let icon = ''

    switch (type) {
        case 'success':
            icon = succesIcon;
            break;
        case 'error':
            icon = errorIcon;
            break;
        case 'warning':
            icon = warningIcon;
            break;
        default:
            icon = '';
    }

    return (
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={open}
            onClose={handleClose}
        >
            <div className="success-animated-paper">
                {icon}
                <FontAwesomeIcon onClick={handleClose} className="success-animated-close-icon" icon={['fas', 'times']} />
                <div className="success-animated-text-container">
                    {children}
                </div>
            </div>
        </Modal>
    );
}

export default SuccesAnimated;
